import { render } from "./RegisterModal.vue?vue&type=template&id=0d13f78c"
import script from "./RegisterModal.vue?vue&type=script&lang=js"
export * from "./RegisterModal.vue?vue&type=script&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=0d13f78c&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__